import { useEffect, useState } from "react";
import { Printer, Truck, PackageCheck, XCircle, ShoppingBag } from "lucide-react";
import api, { API } from "../lib/api";

const ICONS = { printing: Printer, shipped: Truck, delivered: PackageCheck, cancelled: XCircle };
const when = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");
const detail = (s) => {
  const date = when(s.at);
  if (s.status === "printing") return `A ${s.height ? `${s.height} mm ` : ""}print was ordered on ${date} — Zero Ducks Given is printing it now.`;
  if (s.status === "shipped") return `Shipped on ${date}. It's on its way.`;
  if (s.status === "delivered") return `Delivered on ${date}.`;
  return `The print order was cancelled on ${date}.`;
};

// Public, status-only order tracking on the share page (no names, no order numbers).
export const OrderStatusCard = ({ id }) => {
  const [state, setState] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/share/${id}/order-status`).then((r) => alive && setState(r.data)).catch(() => alive && setState(null));
    return () => {
      alive = false;
    };
  }, [id]);

  if (!state?.ordered) return null;
  const Icon = ICONS[state.status] || Printer;
  const live = state.status === "printing";
  return (
    <div data-testid="order-status-card" className="rounded-3xl border border-border bg-card/70 p-4 flex items-center gap-4">
      <span className={`grid place-items-center h-12 w-12 shrink-0 rounded-2xl ${live ? "bg-accent/15 text-accent" : "bg-muted text-foreground"}`}>
        <Icon className={`h-6 w-6 ${live ? "animate-pulse" : ""}`} />
      </span>
      <div className="min-w-0">
        <p data-testid="order-status-label" className="font-heading font-bold leading-tight">
          {state.label}
          {state.orders > 1 && <span className="ml-2 text-xs font-mono2 text-muted-foreground">×{state.orders} ordered</span>}
        </p>
        <p data-testid="order-status-detail" className="text-xs text-muted-foreground mt-0.5">{detail(state)}</p>
      </div>
      {state.status !== "cancelled" && (
        <a
          data-testid="order-status-reorder-link"
          href={`${API}/share/${id}/reorder?height=${state.height || 70}`}
          target="_blank"
          rel="noopener noreferrer"
          title="Order another print of this duck"
          className="ml-auto shrink-0 inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-xs font-semibold hover:border-accent/60 transition-colors"
        >
          <ShoppingBag className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Order another</span>
        </a>
      )}
    </div>
  );
};
